import React from "react";

const metrics = [
    {
        label: "Employees Active",
        value: "97 / 128",
        percentage: 76,
        color: "#2563eb",
    },
    {
        label: "Departments Healthy",
        value: "5 / 5",
        percentage: 100,
        color: "#10b981",
    },
    {
        label: "Office Utilization",
        value: "82%",
        percentage: 82,
        color: "#f59e0b",
    },
    {
        label: "Average Productivity",
        value: "91%",
        percentage: 91,
        color: "#8b5cf6",
    },
];

const OrganizationHealth = () => {
    return (
        <div
            style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "16px",
                padding: "24px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "24px",
                }}
            >
                <div>
                    <h2
                        style={{
                            margin: 0,
                            color: "#0f172a",
                        }}
                    >
                        Organization Health
                    </h2>

                    <p
                        style={{
                            marginTop: "6px",
                            color: "#64748b",
                            fontSize: "14px",
                        }}
                    >
                        Overall operational health of your firm.
                    </p>
                </div>

                <div
                    style={{
                        background: "#ecfdf5",
                        color: "#16a34a",
                        padding: "8px 14px",
                        borderRadius: "999px",
                        fontWeight: 700,
                        fontSize: "15px",
                    }}
                >
                    85% Healthy
                </div>
            </div>

            {metrics.map((item) => (
                <div
                    key={item.label}
                    style={{
                        marginBottom: "22px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "8px",
                            fontWeight: 600,
                        }}
                    >
                        <span>{item.label}</span>

                        <span>{item.value}</span>
                    </div>

                    <div
                        style={{
                            width: "100%",
                            height: "10px",
                            background: "#e5e7eb",
                            borderRadius: "999px",
                            overflow: "hidden",
                        }}
                    >
                        <div
                            style={{
                                width: `${item.percentage}%`,
                                height: "100%",
                                background: item.color,
                                transition: "0.4s",
                            }}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default OrganizationHealth;
